import React, { ChangeEvent, FC } from 'react';
import TextField from '@mui/material/TextField';
import { E164_PHONE_NUMBER_REGEX } from 'constants/assist/phoneNumbers';
import {
  AssistMigrationBusinessSetting,
  AssistMigrationBusinessSettings,
} from 'types/assist/assistMigration';

interface BusinessSettingsEditorProps {
  setting: AssistMigrationBusinessSetting;
  value: AssistMigrationBusinessSettings;
  onChange: (patch: Partial<AssistMigrationBusinessSettings>) => void;
}

export const BusinessSettingsEditor: FC<BusinessSettingsEditorProps> = ({
  setting,
  value,
  onChange,
}) => {
  const transferNumber = value.escalationPhoneNumber ?? '';
  const isTransferNumberValid =
    !transferNumber || transferNumber === 'N/A' || E164_PHONE_NUMBER_REGEX.test(transferNumber);

  const handleWelcomeMessageChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ welcomeMessage: event.target.value || null });
  };

  const handleTransferNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ escalationPhoneNumber: event.target.value || null });
  };

  if (setting === 'welcomeMessage') {
    return (
      <TextField
        size="small"
        label="Welcome message"
        value={value.welcomeMessage ?? ''}
        fullWidth
        multiline
        onChange={handleWelcomeMessageChange}
      />
    );
  }

  return (
    <TextField
      size="small"
      label="Default transfer number"
      value={transferNumber}
      fullWidth
      error={!isTransferNumberValid}
      helperText={isTransferNumberValid ? 'Format: +19999999999 or N/A' : 'Invalid phone number'}
      onChange={handleTransferNumberChange}
    />
  );
};
